import { Skeleton, Stack, Text } from '@sixui/ui';

import type { ITableRowProps } from '~/components/molecules/Table';
import { UserAvatar } from '~/components/atoms/UserAvatar';
import { Table } from '~/components/molecules/Table';

export type ISessionSkeletonProps = ITableRowProps;

export const SessionSkeleton: React.FC<ISessionSkeletonProps> = (props) => {
  const { ...other } = props;

  return (
    <Table.Row {...other}>
      <Stack as={Table.Body} horizontal gap={3}>
        <Skeleton variant="circular">
          <UserAvatar />
        </Skeleton>
        <Stack gap={1}>
          <Text
            as={Skeleton}
            variant="title"
            size="sm"
            length={{ min: 8, max: 24 }}
          />
          <Text
            as={Skeleton}
            variant="body"
            size="sm"
            length={{ min: 8, max: 32 }}
          />
        </Stack>
      </Stack>
      <Table.Body>
        <Skeleton length={{ min: 8, max: 12 }} />
      </Table.Body>
      <Stack as={Table.Body} justify="end">
        <Skeleton length={8} />
      </Stack>
    </Table.Row>
  );
};
